import gql from 'graphql-tag';

export default gql`
    query GetPdf($stageSheetId: Int, $operation: String, $jobId: Int, $key: String) {
        getPdf(stageSheetId: $stageSheetId, operation: $operation, jobId: $jobId, key: $key) {
            sandTicketExtract
        }
    }
`;
